var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125:848)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125:848",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 63,
    height: 63
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 31.5C63 48.897 48.897 63 31.5 63C14.103 63 0 48.897 0 31.5C0 14.103 14.103 0 31.5 0C39.695 0 45.7065 -1.55751e-08 63 4.80707e-07C63 8.442 63 22.2981 63 31.5Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125:848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6154 0.552979L67.6714 40.609L67.5681 68.9993H42.1268L0.418945 27.2914",
    fill: "#3386FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4482 70.223V88.539C63.4482 89.489 62.6777 90.2595 61.7277 90.2595H43.4117C42.9556 90.2595 42.5177 90.0781 42.1952 89.7555L6.99961 54.5599C6.67705 54.2374 6.49561 53.7995 6.49561 53.3434V35.0274C6.49561 34.0774 7.2661 33.3069 8.21614 33.3069H26.5321C26.9882 33.3069 27.4261 33.4883 27.7487 33.8109L62.9436 69.0058C63.2668 69.329 63.4482 69.7662 63.4482 70.223Z",
    fill: "#1660CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2581 35.0508V53.3548C28.2581 53.9023 28.0048 54.3899 27.6086 54.7068L25.2039 52.3021C25.6253 51.9871 25.8981 51.4831 25.8981 50.9155V33.3196H26.5275C27.4832 33.3202 28.2581 34.0951 28.2581 35.0508Z",
    fill: "#7EB3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6085 54.7067C27.3118 54.9442 26.9363 55.086 26.5275 55.086H8.22343C7.26772 55.086 6.49219 54.3111 6.49219 53.3547V52.6472H24.1668C24.5556 52.6472 24.9147 52.5194 25.2038 52.302L27.6085 54.7067Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2038 52.3021C24.9146 52.5195 24.5555 52.6473 24.1668 52.6473H6.49219V35.0508C6.49219 34.6419 6.63394 34.2658 6.87145 33.9697L25.2038 52.3021Z",
    fill: "#D8E8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2235 43.3792V61.6952C90.2235 62.6453 89.453 63.4158 88.503 63.4158H70.187C69.7308 63.4158 69.293 63.2343 68.9704 62.9118L33.7755 27.7162C33.4529 27.3936 33.2715 26.9558 33.2715 26.4997V8.18366C33.2715 7.23362 34.042 6.46313 34.992 6.46313H53.308C53.7641 6.46313 54.202 6.64457 54.5245 6.96713L89.7195 42.1621C90.042 42.4853 90.2235 42.9231 90.2235 43.3792Z",
    fill: "#1660CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.016 8.19511V26.4991C55.016 26.9156 54.8686 27.298 54.6236 27.596L52.1294 25.1018C52.3738 24.8025 52.5213 24.4208 52.5213 24.0037V6.46387H53.2854C54.2411 6.46387 55.016 7.2394 55.016 8.19511Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5204 6.46387V24.0037C52.5204 24.4208 52.373 24.8025 52.1286 25.1018L33.8838 6.85699C34.1818 6.61129 34.5636 6.46387 34.9806 6.46387H52.5204Z",
    fill: "#D8E8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1908 70.226V88.542C90.1908 89.4921 89.4203 90.2626 88.4702 90.2626H70.1543C69.6981 90.2626 69.2603 90.0811 68.9377 89.7586L33.7428 54.5636C33.4202 54.241 33.2388 53.8032 33.2388 53.3471V35.0311C33.2388 34.081 34.0093 33.3105 34.9593 33.3105H53.2753C53.7314 33.3105 54.1693 33.492 54.4918 33.8145L89.6868 69.0095C90.0093 69.3321 90.1908 69.7699 90.1908 70.226Z",
    fill: "#003C89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9839 35.0349V53.339C54.9839 54.2947 54.209 55.0708 53.2526 55.0708H47.5959L45.1011 52.576H50.7578C51.7142 52.576 52.4891 51.7999 52.4891 50.8442V33.3037H53.2526C54.209 33.3037 54.9839 34.0792 54.9839 35.0349Z",
    fill: "#3386FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4891 33.3037V50.8442C52.4891 51.7999 51.7142 52.576 50.7578 52.576H45.1011L33.218 40.693V35.0349C33.218 34.0792 33.9929 33.3037 34.9493 33.3037H52.4891Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1011 52.5759H33.218V40.6929L45.1011 52.5759Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5959 55.071H34.9493C33.9929 55.071 33.218 54.2948 33.218 53.3391V52.5762H45.1011L47.5959 55.071Z",
    fill: "#3386FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6236 27.596C54.5871 27.642 54.5468 27.6854 54.5052 27.727C54.1927 28.0376 53.7605 28.2298 53.2849 28.2298H34.9809C34.0251 28.2298 33.2502 27.4549 33.2502 26.4991V25.735H50.7901C51.2657 25.735 51.6973 25.5434 52.0104 25.2328C52.052 25.1913 52.0923 25.1478 52.1295 25.1018L54.6236 27.596Z",
    fill: "#7EB3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1001 41.291H19.7083V41.2929H20.1001V41.291Z",
    fill: "#7FB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1001 41.291H19.7083V41.2929H20.1001V41.291Z",
    fill: "#062F82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.977 41.2561V41.2574H19.9163C19.9163 41.2561 19.9163 41.2561 19.9163 41.2561H19.977Z",
    fill: "#7FB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1001 41.291H19.7083V41.2929H20.1001V41.291Z",
    fill: "#7FB5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5404 40.9954H20.0994V40.9972H20.5404V40.9954Z",
    fill: "#ADCEFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4011 40.9563H20.0994V40.9576H20.4011V40.9563Z",
    fill: "#ADCEFC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2253 1.85976V26.3655C28.2253 27.3924 27.3924 28.2253 26.3655 28.2253H1.85976C0.83286 28.2253 0 27.3924 0 26.3655V25.5452H23.6855C24.7124 25.5452 25.5452 24.7124 25.5452 23.6855V0H26.3655C27.3924 0 28.2253 0.83286 28.2253 1.85976Z",
    fill: "#D8E8FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5452 0V23.6855C25.5452 24.7124 24.7124 25.5452 23.6855 25.5452H0V1.85976C0 0.83286 0.83286 0 1.85976 0H25.5452Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9811 19.0505C12.3845 19.0505 11.9006 18.5666 11.9006 17.97V7.7577C11.9006 7.16109 12.3845 6.67725 12.9811 6.67725C13.5777 6.67725 14.0615 7.16109 14.0615 7.7577V17.97C14.0615 18.5666 13.5783 19.0505 12.9811 19.0505Z",
    fill: "#8ABF3F",
    stroke: "#8ABF3F",
    strokeWidth: 1.12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0872 13.9443H7.87488C7.27827 13.9443 6.79443 13.4605 6.79443 12.8639C6.79443 12.2673 7.27827 11.7834 7.87488 11.7834H18.0872C18.6838 11.7834 19.1676 12.2673 19.1676 12.8639C19.1676 13.4605 18.6838 13.9443 18.0872 13.9443Z",
    fill: "#8ABF3F",
    stroke: "#8ABF3F",
    strokeWidth: 1.12,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4746 39.4143C45.2285 41.3831 44.2441 42.3674 43.0136 42.3674C41.7832 42.3674 40.7988 41.137 40.5527 39.4143C40.3066 37.6917 41.6545 36.4612 43.0136 36.4612C44.3728 36.4612 45.7207 37.4456 45.4746 39.4143ZM48.4277 48.2737C49.166 45.8127 46.2128 43.3518 43.0136 43.3518C39.8144 43.3518 36.8613 45.8127 37.5996 48.2737H48.4277Z",
    fill: "#3388FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4746 13.6631C45.2285 15.6318 44.2441 16.6162 43.0136 16.6162C41.7832 16.6162 40.7988 15.3857 40.5527 13.6631C40.3066 11.9404 41.6545 10.71 43.0136 10.71C44.3728 10.71 45.7207 11.6943 45.4746 13.6631ZM48.4277 22.5224C49.166 20.0615 46.2128 17.6006 43.0136 17.6006C39.8144 17.6006 36.8613 20.0615 37.5996 22.5224H48.4277Z",
    fill: "#3388FF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9985 39.4143C18.7524 41.3831 17.768 42.3674 16.5375 42.3674C15.3071 42.3674 14.3227 41.137 14.0766 39.4143C13.8305 37.6917 15.1784 36.4612 16.5375 36.4612C17.8967 36.4612 19.2446 37.4456 18.9985 39.4143ZM21.9516 48.2737C22.6899 45.8127 19.7368 43.3518 16.5375 43.3518C13.3383 43.3518 10.3852 45.8127 11.1235 48.2737H21.9516Z",
    fill: "#3388FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9568 33.3899V50.9858C25.9568 51.5534 25.684 52.0568 25.2625 52.3724L6.93018 34.0394C7.24707 33.6432 7.73469 33.3899 8.28216 33.3899H25.9568Z",
    fill: "#ADCEFC",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1295 25.1016C52.0923 25.1476 52.052 25.1911 52.0104 25.2327C51.6979 25.5433 51.2657 25.7348 50.7901 25.7348H33.2502V8.19495C33.2502 7.7193 33.4418 7.28775 33.753 6.97464C33.7946 6.93306 33.838 6.89274 33.884 6.8562L52.1295 25.1016Z",
    fill: "#ADCEFC",
    fillOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125:848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add_user.98751065.svg";
export { ForwardRef as ReactComponent };